<template>
    <div >
        <div class="flex">
            <el-date-picker
                    style="width: 220px"
                    class="marr4"
                    size="small"
                    v-model="valuetime"
                    @change="getTimes"
                    :clearable="false"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
            </el-date-picker>
            <el-input
                    style="width: 220px"
                    class="marr4"
                    size="small"
                    placeholder="搜索"
                    suffix-icon="el-icon-search"
                    @change="gosearch"
                    v-model="vc_search">
            </el-input>
<!--            <el-button :class="baseerp+'btn'"  size="mini" type="primary" @click="opensheet">报表</el-button>-->
        </div>
        <el-table
                v-show="showTable"
                border
                ref="table"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange"
                @select="handleSelect"
                :row-key="getRowKeys"
                v-loading="loading2"
                size="mini"
                :height="tableHeight"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="highlightCurrentRow">
            <el-table-column
                    align="left"
                    type="selection"
                    :reserve-selection="true"
                    width="55">
            </el-table-column>
            <el-table-column
                    prop="i_istemp"
                    label=""
                    show-overflow-tooltip
                    width="95">
                <template slot-scope="scope">
                    <span :class="scope.row.i_istemp==1?'boxyu box marr4':''">{{scope.row.i_istemp==1?'临':''}}</span>
                    <span v-if="scope.row.i_istemp==1" :class="scope.row.i_istemp_over==1?'boxyu boxbu green':'boxyu boxbu'">{{scope.row.i_istemp_over==1?'已补':'未补'}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_xcode"
                    label="销售编号"
                    show-overflow-tooltip
                    width="100"
                    align="left">
               <!-- <template slot-scope="scope">
                    <span>
                        <span :class="scope.row.i_istemp==1?'boxyu box marr4':''">{{scope.row.i_istemp==1?'临':''}}</span>
                        <span v-if="scope.row.i_istemp==1" :class="scope.row.i_istemp_over==1?'boxyu boxbu green':'boxyu boxbu'">{{scope.row.i_istemp_over==1?'已补':'未补'}}</span>
                        {{scope.row.vc_xcode}}
                    </span>
                </template>-->
            </el-table-column>
            <el-table-column
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip
                    width="120"
                    align="left">
            </el-table-column>
            <el-table-column
                    prop="vc_kpname_sell"
                    label="开票品名"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_pzspecs"
                    label="规格型号"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_kpbzstyle_sell"
                    label="开票规格"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_unit"
                    label="单位"
                    show-overflow-tooltip
                    width="80"
                    align="center">
            </el-table-column>
            <el-table-column
                    prop="vc_kpunit_sell"
                    label="开票单位"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_price"
                    label="订单单价"
                    show-overflow-tooltip
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="f_num"
                    label="开单量/出库量/签收量"
                    show-overflow-tooltip
                    width="140"
                    align="right">
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{scope.row.f_kdnum+'/'+scope.row.f_outnum+'/'+scope.row.f_signnum}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="f_num"
                    label="待开票量"
                    show-overflow-tooltip
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="f_kpnum_sell"
                    label="开票数量"
                    show-overflow-tooltip
                    width="125">
                <template slot-scope="scope">
                    <el-input-number @change="changenum(tableData,scope.$index,scope.row)" :controls="false" :min="0" :precision="$setPrecision.quantityPrecision"  size="mini" v-model="scope.row.f_kpnum_sell" ></el-input-number>
                </template>
            </el-table-column>
            <!--<el-table-column
                    prop="f_invoicednum"
                    label="已开票数量"
                    show-overflow-tooltip
                    align="right">
            </el-table-column>-->
            <el-table-column
                    prop="f_amount"
                    label="开票金额"
                    show-overflow-tooltip
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="vc_note"
                    label="发票备注"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_thtype"
                    label="提货方式"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_kduname"
                    label="业务"
                    show-overflow-tooltip
                    align="left">
            </el-table-column>
            <el-table-column
                    prop="vc_email"
                    label="发票接收邮箱"
                    show-overflow-tooltip
                    width="120">
            </el-table-column>
            <!--<el-table-column
                    prop="vc_lruname"
                    label="申请人"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    prop="dt_applytime"
                    label="申请时间"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    prop="i_state"
                    label="开票状态"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{ scope.row.i_state==0?'待提交':(scope.row.i_state==1?'已提交':'已开票') }}</span>
                </template>
            </el-table-column>-->
            <el-table-column
                    prop="dt_yjdhtime"
                    label="预计到货时间"
                    show-overflow-tooltip
                    width="95">
            </el-table-column>
            <!--<el-table-column
                    prop="vc_invoice_code"
                    label="发票代码"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column label="操作" width="120">
                <template slot-scope="scope" >
                    <el-button size="mini"
                               type="text"
                               @click="handleAdd(scope.$index, scope.row)">新增</el-button>
                    <el-button size="mini"
                               type="text"
                               @click="returndown(scope.$index, scope.row)">转线下</el-button>
                </template>
            </el-table-column>-->
        </el-table>
        <div class="flex_e padT6 mrr9">
            <el-button :class="baseerp+'btn'"  size="small" type="primary" @click="sureset">{{$t('button_confirm')}}</el-button>
<!--            <el-button :class="baseerp+'btn'"  size="small" type="primary" @click="plset('add')">批量新增</el-button>-->
<!--            <el-button :class="baseerp+'btn'"  size="small" type="primary" @click="plset('down')">批量转线下</el-button>-->
        </div>
        <div>
            <el-pagination
                    class="flex_e padT6"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[20, 30, 50]"
                    :page-size="pageSize"
                    layout="sizes, prev, pager, next"
                    :total="tableTotal">
            </el-pagination>
            <!--<div class="flex_b alc">
                <div>
                    {{'已选'+ ' '+multipleSelection.length+' '+'条'}}
                </div>
                <el-button :class="baseerp+'btn'"  size="small"  @click="sure">确定</el-button>
                &lt;!&ndash;<div class="flex alc">
                    <div class="marr4">
                        <div style="color: #9e9e9e;font-size: 12px">{{'开票总额'}}</div>
                        <div>{{totalPrice}}</div>
                    </div>
                    <el-button :class="baseerp+'btn'"  size="small" type="primary">确定</el-button>
                </div>&ndash;&gt;
            </div>-->
        </div>
        <!--dialog-->
        <el-dialog
                :class="baseerp+'div'"
                width="1000px"
                :title="title"
                :visible.sync="dialogVisible_add"
                :close-on-click-modal="false"
                @close="cancelDialog_add"
                v-if="dialogVisible_add"
                :append-to-body="true">
<!--            <add-kp :addData="addData"  @cancelDialog_add="cancelDialog_add"></add-kp>-->
        </el-dialog>
    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    //import addKp from "./addKp";
    export default {
        name: "",
        components: {
            //addKp,
        },
        props:{
            Data:{
                type:Object,
                required:true,
            }
        },
        data(){
            return{
                showTable:true,
                getRowKeys(row){
                    return row.uniqueKey
                },
                baseerp:"",
                mid:0,
                title:"新增开票",
                dialogVisible_add:false,
                dialogVisible_sheet:false,
                addData:{},
                i_gsid:0,
                loading2:true,
                vc_search:"",
                highlightCurrentRow:false,
                pageSize:20,
                currentPage:1,
                tableTotal:0,
                valuetime:'',
                dt_startdate:'',
                dt_enddate:'',
                tableData: [],
                multipleSelection: [],
                multipleSelection_2:[],
                tableHeight:0,
            }
        },

        mounted() {
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            this.baseerp=baseerp;
            //console.log('data',this.Data);
            //this.i_gsid = this.Data.i_gsid;
            this.getfMou();
            this.$nextTick(function () {
                this.onResize();
            });

        },
        methods:{
            onResize(n){
                if (n==undefined) n=this.$root.workSize;
                this.tableHeight = n.h - 160;
                //this.tableHeight = $("#page").height()*1 -  $("#toolH").height()*1 ;
                // console.log(n.h,this.tableHeight)
            },
            opensheet(){
                let arg={
                    "i_gsid": this.i_gsid,
                    "vc_search": this.vc_search,
                    'dt_startdate':this.dt_startdate,
                    'dt_enddate':this.dt_enddate,
                };
                this.$emit('bbSheet',arg);
            },
            refreshTable(){
                this.showTable=false;
                this.$nextTick(()=>{
                    this.showTable=true;
                })
            },
            changenum(data,index,row){
                let e = row.f_kpnum_sell;
                if(e>row.f_validnum||e==0){
                    this.$message.error('开票数量不能大于待开票量且不能为0！');
                    row.f_kpnum_sell =row.f_validnum;
                    row.f_num = row.f_validnum / 1;
                }else{
                    row.f_kpnum_sell = e;
                    let price = row.f_kpnum_sell * row.f_kpprice_sell;
                    row.f_amount = Math.round(parseFloat(price) * 100) / 100;
                    row.f_num = row.f_kpnum_sell / row.f_bl
                }
                //console.log(row.f_num,'row.f_num')
                this.$set(data,index,row);
                this.$nextTick(()=>{
                    this.$forceUpdate()
                })
            },
            sureset(){
                //console.log(' this.multipleSelection', this.multipleSelection)
                const oldData= this.Data.select;//旧数据
                let oldDataRepetition = [].concat(oldData);    //使用空数组合并，之后操作不改变原数组
                const dataSource = this.multipleSelection;//新数据
                let dataSourceRepetition = [].concat(dataSource);
                let someArr = [];   //相同的
                for (let i = 0; i < dataSource.length; i++) {
                    for (let j = 0; j < oldData.length; j++) {
                        if (oldData[j].uniqueKey === dataSource[i].uniqueKey) {
                            someArr.push(oldData[j]);
                        }
                    }
                }
                let deleteArr = [];  //删除的
                for (let i = 0; i < someArr.length; i++) {
                    for (let j = 0; j < oldDataRepetition.length; j++) {
                        if (someArr[i].uniqueKey === oldDataRepetition[j].uniqueKey) {
                            oldDataRepetition.splice(j, 1);    //去重
                        }
                    }
                }
                deleteArr = oldDataRepetition;
                let addArr = [];  //增加的
                for (let i = 0; i < someArr.length; i++) {
                    for (let j = 0; j < dataSourceRepetition.length; j++) {
                        if (someArr[i].uniqueKey === dataSourceRepetition[j].uniqueKey) {
                            dataSourceRepetition.splice(j, 1);    //去重
                        }
                    }
                }
                addArr = dataSourceRepetition;
                //console.log(deleteArr,'deleteArr')
                //console.log(addArr,'addArr')
                let map={
                    deleteArr:deleteArr,
                    addArr:addArr,
                }
                this.$emit('cancelDialog',map)

            },
            plset(type){
                this.$confirm('是否确认批量新增/线下开票？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //console.log(' this.multipleSelection', this.multipleSelection)
                    if(type=='add'){
                        this.saveForm()
                    }else if(type=='down'){
                        this.offline(this.multipleSelection)
                    }

                }).catch(() => {

                });
            },
            //保存
            async saveForm(){
                let kong = this.multipleSelection.some(item=>{
                    return item.vc_creditcode==''
                })
                //console.log('kong',kong)
                if(kong){
                    this.$message.error('请前往OA维护客户纳税人识别号！');
                    return;
                };
                //let alist=[];
                //alist.push(this.formData);
                this.loading2=true;
                let param={
                    delSub:[],
                    list:this.multipleSelection,
                };
                let res=await API.saveInvoice(param);
                if (res.code==1){
                    this.loading2=false;
                    this.currentPage=1;
                    this.tableData=[];
                    this.getList();
                }else if (res.code == -2) {
                    this.loading2=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading2=false;
                    this.$message.error(res.message);
                }
            },
            returndown(index, row){
                this.$confirm('是否确认线下开票？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //console.log('row',row)
                    /*let map={
                        vc_xcode:row.vc_xcode,
                        i_pzid:row.i_pzid,
                    }*/
                    let arr=[];
                        arr.push(row);
                    //console.log('arr',arr)
                    this.offline(arr)
                }).catch(() => {

                });
            },
            //转线下开票
            async offline(arr){
                this.loading2=true;
                let param={
                    'list':arr,
                };
                var res = await API.offline(param);
                if (res.code==1){
                    this.loading2=false;
                    this.currentPage=1;
                    this.tableData=[];
                    this.getList();
                }else if (res.code == -2) {
                    this.loading2=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading2=false;
                    this.$message.error(res.message);
                }
            },
            handleAdd(index, row){
                this.addData={
                    item:row,
                };
                this.dialogVisible_add=true;
            },
            cancelDialog_add(val){
                this.addData={};
                this.dialogVisible_add=false;
                if(val=='new'){
                    this.$emit('cancelDialog',val)
                }else if(val=='kpzl'){
                    this.currentPage=1;
                    this.tableData=[];
                    this.getList();
                }
            },
            uniqueByKey(arr, key) {
                let seen = new Set();
                return arr.filter((item) => {
                    let keyValue = item[key];
                    if (seen.has(keyValue)) {
                        return false;
                    } else {
                        seen.add(keyValue);
                        return true;
                    }
                });
            },
            sure(){
                /*console.log(this.multipleSelection,'this.multipleSelection');
                console.log(this.multipleSelection_2,'this.multipleSelection_2');
                let uniqueItems = this.uniqueByKey(this.multipleSelection_2, 'uniqueKey');
                console.log('uniqueItems',uniqueItems);
                this.$emit('cancelDialog',uniqueItems)*/
            },
            handleSelect(selection,row){
                let idx = this.tableData.findIndex(item => item===row);
                //console.log('idx',idx)
                return;
                this.tableData[idx].f_sqpay = parseFloat(this.tableData[idx].f_je) - parseFloat(this.tableData[idx].f_sqpay_total);
                let totalsq = parseFloat(this.tableData[idx].f_sqpay) + parseFloat(this.tableData[idx].f_sqpay_total);
                //console.log('totalsq',totalsq);
                let totalbl = this.preciseDiv(totalsq,  parseFloat(this.tableData[idx].f_je));
                //console.log('totalbl',totalbl);
                totalbl = this.toPercentage(parseFloat(this.keepTwoDecimal(totalbl)));
                //console.log('totalbl2',totalbl);
                let nowbl =  this.preciseDiv(parseFloat(this.tableData[idx].f_sqpay),  parseFloat(this.tableData[idx].f_je));
                //console.log('nowbl',nowbl);
                nowbl = this.toPercentage(parseFloat(this.keepTwoDecimal(nowbl)));
                //console.log('nowbl2',nowbl);
                this.tableData[idx].totalbl = totalbl;
                this.tableData[idx].nowbl = nowbl;
            },
            handleSelectionChange(val) {
                //console.log(val,'val')
                this.multipleSelection = val;
                this.multipleSelection_2 = [...this.multipleSelection_2 , ...val];
            },
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },

            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getList();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getList();
            },
            //列表list
            async getList(){
                this.loading2=true;
                let param={
                    'i_mid':this.mid,
                    "i_gsid": 0,
                    "vc_gsname": this.Data.orderData.sellerName,
                     vc_khname: this.Data.orderData.buyerName,
                    "vc_search": this.vc_search,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                    'dt_startdate':this.dt_startdate,
                    'dt_enddate':this.dt_enddate,
                    invoiceNum:this.Data.orderData.invoiceNum,
                    electronicNumber:this.Data.orderData.electronicNumber,
                };
                var res = await API.listBeforeInvoice(param);
                if (res.code==1){
                    /*res.data.list.map(item=>{
                        let hush=[];
                        hush.push(item.list[0]);
                        item.showpzlist=hush;
                        item.pzlen=item.list.length;
                    })*/
                    this.tableData=res.data.list;
                    this.tableTotal=res.data.total;
                    this.loading2=false;
                    this.$nextTick(()=>{
                        for(let i=0;i<this.tableData.length;i++){
                            let pz= this.tableData[i];
                            for(let s of this.Data.select){
                                if(pz.uniqueKey==s.uniqueKey){
                                    this.$refs.table.toggleRowSelection(this.tableData[i],true)
                                }
                            }
                        }
                    });
                    // console.log('this.multipleSelection_2',this.multipleSelection_2)
                }else if (res.code == -2) {
                    this.loading2=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading2=false;
                    this.$message.error(res.message);
                }
            },
            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                // console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                // console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getList();
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                // console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    // console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },



        },
    }
</script>


<style  lang="scss" scoped>
    /deep/.el-table td{

    }
    .green{
        background-color: green !important;
    }
    .boxyu{
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .boxbu{
        width: 38px;
        height: 28px;
        line-height: 25px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .cgdia {
        //弹出层里内容 样式
        /deep/.el-dialog__body {
            max-height: 85vh !important;
            overflow-y: auto;
            padding: 6px !important;
        }

    }

    .flex_e{
        display: flex;
        justify-content: end;
    }
    .mar9{
        margin: 9px;
    }
    .alc{
        align-items: center;
    }
    .flex{
        display: flex;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 6px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }



</style>
